import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "app-sidebar-footer flex-column-auto pt-2 pb-6 px-6",
  id: "kt_app_sidebar_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://devinci.fr",
  class: "btn btn-flex flex-center btn-custom btn-primary overflow-hidden text-nowrap px-0 h-40px w-100",
  "data-bs-toggle": "tooltip",
  "data-bs-trigger": "hover",
  "data-bs-dismiss-": "click",
  title: "200+ in-house components and 3rd-party plugins"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn-label" }, "2023 © Léonard de Vinci")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}